import axios from "axios";

const axiosAdmin = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/admin`,
  withCredentials: true,
});

axiosAdmin.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default axiosAdmin;
